"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ListItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenUtils = require("@8x8/oxygen-utils");
var _themeName = _interopRequireDefault(require("../constants/themeName"));
var _ListItemStyled = _interopRequireDefault(require("../styled/ListItemStyled"));
var _excluded = ["children", "title", "isDisabled", "isActive", "shouldWrapText", "onClick"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ListItem = function ListItem(_ref) {
  var children = _ref.children,
    title = _ref.title,
    isDisabled = _ref.isDisabled,
    isActive = _ref.isActive,
    shouldWrapText = _ref.shouldWrapText,
    onClick = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  function handleClick(e) {
    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    onClick(e);
  }
  var handleOnKeyDown = function handleOnKeyDown(ev) {
    if ((0, _oxygenUtils.isEnterEvent)(ev) || (0, _oxygenUtils.isSpaceEvent)(ev)) {
      handleClick(ev);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_ListItemStyled["default"], _extends({
    tabIndex: "0",
    title: title,
    isDisabled: isDisabled,
    isActive: isActive,
    shouldWrapText: shouldWrapText
    // eslint-disable-next-line react/jsx-no-bind
    ,
    onClick: handleClick
  }, otherProps, isDisabled && {
    'aria-disabled': true
  }, !isDisabled && {
    onKeyDown: handleOnKeyDown
  }), children);
};
exports.ListItem = ListItem;
ListItem.propTypes = {
  /**
   * Rendered text inside list item
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * Add title attribute to list item
   */
  title: _propTypes["default"].string,
  /**
   * Tell when list item is disabled
   */
  isDisabled: _propTypes["default"].bool,
  /**
   * Tell when list item is active
   */
  isActive: _propTypes["default"].bool,
  /**
   * Tell when list item should wrap text
   */
  shouldWrapText: _propTypes["default"].bool,
  /**
   * Callback when clicking the item
   */
  onClick: _propTypes["default"].func
};
ListItem.defaultProps = {
  title: undefined,
  isDisabled: false,
  isActive: false,
  shouldWrapText: false,
  onClick: _lodash["default"]
};
var _default = (0, _oxygenConfig.withTheme)(ListItem, _themeName["default"]);
exports["default"] = _default;